import Cookies from 'js-cookie';

/**
 * Returns the domain name from hostname, e.g. bestcamp.com when given booking.bestcamp.com
 * @param hostname
 */
export const getDomain = (hostname: string): string => {
  return hostname
    .split('.')
    .reverse()
    .splice(0, 2)
    .reverse()
    .join('.');
};

export const setCookie = (name: string, value: string, days?: number): void => {
  // Domain must be set so that WP (bestcamp.com domain) is able to access the cookie
  // (by default only subdomain is able to access)
  const domain = getDomain(window.location.hostname);
  if (days) {
    Cookies.set(name, value, { expires: days, domain: domain });
  } else {
    Cookies.set(name, value, { domain: domain });
  }
};

export const getCookie = (name: any): string | null => {
  const cookieValue = Cookies.get(name);
  if (cookieValue) {
    return cookieValue;
  }
  return null;
};

export const eraseCookie = (name: string): void => {
  Cookies.remove(name, { domain: getDomain(window.location.hostname) });
};

/**
 * Check if cookie consent is in URL. When user comes
 * to booking system from WordPress site, the cookie consent
 * is read from CookieBot plugin and set to URL parameters.
 * @param string search string
 * @returns true if all cookie parameters are included in url
 */
export const isConsentInURLParams = (searchString: string): boolean => {
  const searchParams = new URLSearchParams(searchString);
  const consentParams = [
    'preferences',
    'statistics',
    'marketing',
    'doNotTrack',
  ];

  return consentParams.every((param) => searchParams.has(param));
};

export const defaultConsent = {
  preferences: false,
  statistics: false,
  marketing: false,
  doNotTrack: false,
};

/**
 * When user comes to booking system from WordPress site,
 * the cookie consent is read from CookieBot plugin and then
 * set to URL parameters. This function reads those consent
 * values from search string and returns an object representing
 * cookie consent. If some value is not exactly 'true', it's set
 * to false.
 * @param string search string
 * @returns CookieConsent object
 */
export const getConsentFromSearchString = (
  searchString: string,
): CookieConsent => {
  if (!searchString) return defaultConsent;
  const params = new URLSearchParams(searchString);

  return {
    preferences: params.get('preferences') === 'true',
    statistics: params.get('statistics') === 'true',
    marketing: params.get('marketing') === 'true',
    doNotTrack: params.get('doNotTrack') === 'true',
  };
};
